import React, {MouseEvent, Suspense, useRef, useState} from 'react';
import {Styles} from "react-modal";
import {useDispatch} from "react-redux";
import SideDropdown from "components/SideDrop/SideDropdown";
import {
    CustomLightTrashIcon,
    CustomPlusIcon,
    DropTabDiv,
    List,
    NameSpan,
    Search
} from "components/SideDrop/TabsSideDropdown/tabsDropStyles";
import {IPage, setActivePage} from 'store/reducers/QuotesPageReducer';
import {useClickOutside} from 'hooks/useClickOutside';
import {useAppSelector} from "../../../hooks/redux";
import {removeTab} from 'store/reducers/TabsSlice';
import {IProps} from "../TabsLayoutDropdown/TabsLayoutDropdown";
import CreateTabModal from "../../CreateTabModal/CreateTabModal";
import Cookies from "js-cookie";
import {setActivePageId} from 'store/reducers/quotes';

const AreYouSureModal = React.lazy(() => import('components/AreYouSureModal/AreYouSureModal'))

const customStyle: Styles = {
    overlay: {
        position: 'fixed',
        zIndex: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        position: "static",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "350px",
        height: "210px",
        boxShadow: "0px 0px 5px rgba(49, 69, 49, 0.14)",
        borderRadius: "10px"
    }
}

const TabsSideDropdown = ({isOpen, ref, wrapperRef, closeHandler}: IProps) => {
    const dispatch = useDispatch()
    const {pages, activePage} = useAppSelector(state => state.quotesPage)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchName, setSearchName] = useState("");
    const [deletingTabId, setDeletingTabId] = useState(0);
    const [deletingTabName, setDeletingTabName] = useState("");
    const [isAreYouSureModalOpen, setIsAreYouSureModalOpen] = useState(false)

    const currentTab = useAppSelector(state => state.tabs.currentTab)

    const trashRef = useRef(null)

    useClickOutside(isOpen, ref, closeHandler)
    useClickOutside(isOpen, wrapperRef, closeHandler)

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
        setSearchName(e.currentTarget.value.toLowerCase())
    };

    const handleDeleteSureModalOpen = (id: number, name: string) => {
        setDeletingTabId(id)
        setDeletingTabName(name)
        setIsAreYouSureModalOpen(true)

    };

    const handleTabDeleteClick = () => {
        dispatch(removeTab(deletingTabId))
        setIsAreYouSureModalOpen(false)
        dispatch(setActivePage(null))

    };

    const setPage = (e: MouseEvent, id: number) => {
        const target = e.target as Element;
        if (id === activePage?.id || target.id === 'trash_icon') return;
        Cookies.set('activePageId', id.toString())
        dispatch(setActivePageId(id.toString()))
        dispatch(setActivePage(id))
    }

    const plusIcon = <CustomPlusIcon onClick={openModal}/>
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <div>
                {
                    isAreYouSureModalOpen &&
                    <AreYouSureModal
                        title={`Удалить вкладку ${deletingTabName}? Все настройки вкладки удалятся безвозвратно`}
                        isOpen={isAreYouSureModalOpen}
                        onRequestClose={() => setIsAreYouSureModalOpen(false)}
                        onApplyClick={handleTabDeleteClick}
                    />
                }
                <SideDropdown dropTitle={"Вкладки"} plusIcon={plusIcon}>
                    <>
                        <Search onChange={handleSearchChange} placeholder={"Поиск"}/>
                        <List>
                            {pages
                                ?.filter((item: IPage) => item?.name?.toLowerCase().includes(searchName))
                                ?.sort((a, b) => b.id - a.id)
                                .map((item: IPage) => (
                                    <DropTabDiv
                                        isActive={item.id === currentTab.id}
                                        key={`dd_tab_${item.id}`}
                                    >
                                        <NameSpan onClick={(e) => setPage(e, item.id)}
                                                  key={item.id}>{item.name}</NameSpan>
                                        <CustomLightTrashIcon ref={trashRef} id="trash_icon"
                                                              onClick={() => handleDeleteSureModalOpen(item.id, item.name)}/>
                                    </DropTabDiv>
                                ))}
                        </List>
                    </>
                </SideDropdown>
            </div>
            <CreateTabModal
                isModalOpen={isModalOpen}
                closeModal={closeModal}
                customStyle={customStyle}
            />
        </Suspense>
    );
};

export default TabsSideDropdown;
